// Ruta: frontend/src/shared/layout/MainLayout.tsx
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '@core/hooks/useAuth';

const MainLayout = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white shadow">
        <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8 flex justify-between items-center">
          <h1 className="text-xl font-bold text-gray-900">Inspección Checklist</h1>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-700">{user?.email}</span>
            <button onClick={logout} className="text-sm text-red-600 hover:text-red-800">
              Cerrar sesión
            </button>
          </div>
        </div>
        <nav className="bg-gray-50 border-t border-gray-200">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex space-x-4 py-3">
              <Link to="/" className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium">Dashboard</Link>
              <Link to="/checklists" className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium">Checklists</Link>
              <Link to="/scanner" className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium">Escanear QR</Link>
            </div>
          </div>
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;